import { animate, animateChild, query, state, style, transition, trigger } from '@angular/animations';

export function routerTransition() {
    return trigger('routerTransition', [
        state('void', style({ position: 'absolute', top: 0, left: 0, width: '100%' })),
        transition(':enter', [
            style({ transform: 'translateY(20%)', opacity: '0' }),
            animate('400ms cubic-bezier(0.4, 0.0, 0.2, 1)', style({ transform: '*', opacity: '1' })),
            query('@*', animateChild(), { optional: true }),
        ]),
    ]);
}
